import { isAddress } from "@certn/cascadia";
import { PrimaryTag, Text } from "@certn/cascadia-react";
import {
  CascadiaControlProps,
  CascadiaJsonFormContext,
  withCascadiaControlProps,
} from "@certn/forms";
import { formatDate } from "@certn/utils";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { sortResidencesByDate } from "../residences-sort-utils";
import { ResidencesArrayControlSummary } from "./ResidencesArrayControlSummary";
import { ArrayModalControl } from "../array-modal-control/ArrayModalControl";

export function ResidencesArrayControl(props: CascadiaControlProps) {
  const { t } = useTranslation();

  const form = useContext(CascadiaJsonFormContext);

  const displayedDateGranularity =
    props.uischema.options?.displayedDateGranularity;

  if (form.isSummary) {
    return <ResidencesArrayControlSummary {...props} />;
  }

  return (
    <ArrayModalControl
      {...props}
      sortComparator={sortResidencesByDate}
      renderTag={({ end_date }) =>
        !end_date ? <PrimaryTag type="subtle">{t("Current")}</PrimaryTag> : null
      }
      renderSubtitle={({ address, start_date, end_date }) => {
        if (!isAddress(address)) {
          return null;
        }

        return (
          <>
            <Text style="global/body-secondary" color="text-weak">
              {[
                address.locality,
                address.administrative_division_1,
                address.country,
              ]
                .filter(Boolean)
                .join(", ")}
            </Text>
            <Text style="global/body-secondary" color="text-weak">
              {[start_date, end_date]
                .map((date) => {
                  if (typeof date !== "string") {
                    return null;
                  }

                  return formatDate(
                    date,
                    displayedDateGranularity === "month"
                      ? "MMM yyyy"
                      : "dd MMM yyyy",
                    t("Present")
                  );
                })
                .filter(Boolean)
                .join(" - ")}
            </Text>
          </>
        );
      }}
    />
  );
}

ResidencesArrayControl.displayName = "ResidencesArrayControl";

export const ResidencesArrayControlRenderer = withCascadiaControlProps(
  ResidencesArrayControl,
  { alwaysShowErrors: true }
);
